<template>
  <ClientOnly placeholder-tag="button">
    <FavoritesButton @click="toggleFavorite" :isActive="isActive" />
  </ClientOnly>
</template>

<script setup lang="ts">
const props = defineProps<{
  uuid: string
  title: string
  date: Date
  path: string
}>()

const { addFavorite, hasFavorite, removeFavorite } = useFavorites()

const isActive = computed(() => hasFavorite(props.uuid))

const toggleFavorite = () => {
  const item = {
    uuid: props.uuid,
    title: props.title,
    date: props.date,
    path: props.path,
  }

  unref(isActive) ? removeFavorite(props.uuid) : addFavorite(item)
}
</script>
